import { useEffect } from 'react';

const SEOHead = () => {
  useEffect(() => {
    // Add Schema.org structured data
    const businessSchema = {
      '@context': 'https://schema.org',
      '@type': 'HomeAndConstructionBusiness',
      name: 'Ideas Costa Blanca',
      description: 'Empresa integral de construcción, reformas y mantenimiento en Costa Blanca',
      telephone: '+34 604 150 871',
      email: 'info@ideascostablanca.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Costa Blanca',
        addressRegion: 'Alicante',
        addressCountry: 'ES',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '38.3452',
        longitude: '-0.4810',
      },
      openingHours: 'Mo-Fr 08:00-19:00, Sa 09:00-14:00',
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Servicios de construcción y mantenimiento',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Reformas Integrales',
              description: 'Cocinas, baños, salones, viviendas completas',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Construcción en General',
              description: 'Obra nueva, ampliaciones, piscinas, cerramientos y terrazas',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Portones Automáticos',
              description: 'Instalación y mantenimiento para garajes, comunidades y empresas, urgencias 24h',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Tratamientos de Agua',
              description: 'Ósmosis inversa, descalcificadores, filtros para agua dura',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Climatización y Aerotermia',
              description: 'Aerotermia, aire acondicionado, refrigeración y calefacción',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Mantenimiento Integral',
              description: 'Electricidad, fontanería, carpintería, cerrajería y todos los oficios',
            },
          },
        ],
      },
      areaServed: [
        'Alicante',
        'Benidorm',
        'Torrevieja',
        'Altea',
        'Calpe',
        'Denia',
        'Costa Blanca',
      ],
    };

    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '¿Cuánto tiempo tarda una reforma integral?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'El tiempo depende del tamaño y complejidad del proyecto. Una reforma de cocina o baño suele tardar entre 2-3 semanas, mientras que una vivienda completa puede requerir de 6 a 12 semanas. Siempre establecemos un calendario detallado antes de comenzar y nos comprometemos a cumplir los plazos acordados.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Ofrecen garantía en los trabajos realizados?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí, todos nuestros trabajos incluyen garantía. La duración varía según el tipo de obra, como 2 años en reparaciones. Además, todos los materiales cuentan con la garantía del fabricante y nosotros actuamos como intermediarios para cualquier incidencia.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Trabajan en toda la Costa Blanca?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí, trabajamos en toda la provincia de Alicante y la Costa Blanca, incluyendo Alicante ciudad, Benidorm, Torrevieja, Altea, Calpe, Denia, y todas las localidades intermedias. Nuestro equipo está distribuido estratégicamente para ofrecer un servicio rápido en cualquier zona.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Cómo funciona el proceso de presupuesto?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Es muy sencillo: (1) Nos contactas por teléfono, email o formulario. (2) Concertamos una visita gratuita para evaluar el proyecto. (3) Te entregamos un presupuesto detallado por escrito en un plazo de 48-72 horas. (4) Si lo aceptas, acordamos fechas y comenzamos. Sin compromisos ni costes ocultos.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Qué soluciones ofrecen para el agua dura de la zona?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'La Costa Blanca tiene agua especialmente dura con alto contenido de cal. Ofrecemos varias soluciones: descalcificadores por intercambio iónico (ideales para toda la vivienda), sistemas de ósmosis inversa (agua de consumo), y filtros especializados. Realizamos un análisis gratuito del agua para recomendar la mejor opción.',
          },
        },
      ],
    };

    // Insert schemas into head
    const businessScriptTag = document.createElement('script');
    businessScriptTag.type = 'application/ld+json';
    businessScriptTag.text = JSON.stringify(businessSchema);
    document.head.appendChild(businessScriptTag);

    const faqScriptTag = document.createElement('script');
    faqScriptTag.type = 'application/ld+json';
    faqScriptTag.text = JSON.stringify(faqSchema);
    document.head.appendChild(faqScriptTag);

    // Cleanup
    return () => {
      document.head.removeChild(businessScriptTag);
      document.head.removeChild(faqScriptTag);
    };
  }, []);

  return null;
};

export default SEOHead;
